
import { hermioneMediaArray } from './hermioneMedia'
import { ronReviewerProfile, dumbledoreReviewerProfile, harryReviewerProfile } from './hermioneReviewers'
import { hermioneBio, ronBio, dumbledoreBio, harryBio } from './hermioneBios'
import { hermioneDatingProfileHinge, hermioneDatingProfileBumble, hermioneDatingProfileTinder } from './hermioneDatingProfiles'

export const hermioneUser = {
  _id: 'hermioneUserId',
  email: 'hermione@email.com',
  acceptedTOS: true,
  subscriptionIsActive: true,
  isReviewer: false,
  reviewerProfilesToSelectFrom: [
    { ...ronReviewerProfile },
    { ...dumbledoreReviewerProfile },
    { ...harryReviewerProfile }
  ],
  media: [ ...hermioneMediaArray ],
  bio: { ...hermioneBio },
  datingProfiles: [
    { ...hermioneDatingProfileHinge },
    { ...hermioneDatingProfileBumble },
    { ...hermioneDatingProfileTinder }
  ],
  reviewerProfile: {},
}

export const ronUser = {
  _id: 'ronUserId',
  email: 'ron@email.com',
  acceptedTOS: true,
  subscriptionIsActive: true,
  isReviewer: true,
  reviewerProfilesToSelectFrom: [],
  media: [],
  bio: { ...ronBio },
  datingProfiles: [],
  reviewerProfile: { ...ronReviewerProfile },
}

export const dumbledoreUser = {
  _id: 'dumbledoreUserId',
  email: 'dumbledore@email.com',
  acceptedTOS: true,
  subscriptionIsActive: true,
  isReviewer: true,
  reviewerProfilesToSelectFrom: [],
  media: [],
  bio: { ...dumbledoreBio },
  datingProfiles: [],
  reviewerProfile: { ...dumbledoreReviewerProfile },
}

export const harryUser = {
  _id: 'harryUserId',
  email: 'harry@email.com',
  acceptedTOS: true,
  subscriptionIsActive: true,
  isReviewer: true,
  reviewerProfilesToSelectFrom: [],
  media: [],
  bio: { ...harryBio },
  datingProfiles: [],
  reviewerProfile: { ...harryReviewerProfile },
}
